import React, { Component } from "react";
import DiceApp from "./DiceApp";
import ScorerApp from "./ScorerApp";
 
class Stuff extends Component {
  render() {
    return (
      <div>
        <div className="dice-app-cont">
          <h2>Dice Roller</h2>
          <DiceApp />
        </div>
        <div className="scorer-app-cont">
          <h2>Numpad</h2>
          <ScorerApp />
        </div>
      </div>
    );
  }
}
 
export default Stuff;


// WEBPACK FOOTER //
// ./src/Stuff.js